import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import React from 'react';
import { StructuredText } from 'react-datocms';

function ContentContact({ items })
{
  return (
    <div className="max-w-3xl mx-auto pt-16">
      <h1>Contact</h1>
      <div className="flex flex-wrap md:flex-nowrap ">
        <div className="p-nomb">
          <StructuredText data={items[0].text} />
        </div>
        <div className="flex-grow">
          <GatsbyImage image={getImage(items[1].text.blocks[0].image)} alt="Hans and Maria" className="h-full" />
        </div>
      </div>
    </div>
  );
}

export default ContentContact;